enum PackageRestrictions {
  OPEN = 'O',
  PRIVATE = 'I',
  CURATOR = 'B',
}

export default PackageRestrictions;
